export default "__VITE_ASSET__H9Hvifck__"